<template>
    <Transition name="fade">
        <div v-if="show"
            class="better-box text-14px font-500 z-999999 fixed bottom-0px w-100% p-13px text-center left-50% transform -translate-x-1/2 transform-origin-center pb-20px">
            <div class="flex items-center justify-between">
                <div class="w-43px h-43px rounded-full overflow-hidden">
                    <van-image :src="avatar" class="w-full h-full">
                        <template v-slot:loading>
                            <div class="w-31px h-31px">
                                <img src="@/assets/images/message/defaultAvatar.webp" alt="" class="w-full h-full"
                                    @load="handleLoad" />
                            </div>
                        </template>
                    </van-image>
                </div>
                <div class="mt-10px" @click="handleClose">
                    <img src="@/assets/images/message/close_com.svg" alt="" class="w-24px h-24px" />
                </div>
            </div>
            <div class="w-full h-190px relative">
                <div class="w-full h-200px absolute top-0 right-0">
                    <img src="@/assets/images/message/better.svg" alt="" class="w-full h-full" />
                    <div class="w-full h-full absolute top-0 right-0 px-20px pt-20px">
                        <div class="text-14px font-500 text-center color-#000 mt-40px text-left">
                            Can you tell me your name? That way I can address you better!
                        </div>
                        <div class="w-full bg-color mt-20px rounded-10px">
                            <input type="text" class="w-full h-40px p-10px" placeholder="Your name"
                                v-model="nickname"  @blur="handleBlur"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-primary" @click="handleConfirm">
                Confirm
            </div>
        </div>
    </Transition>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { UserInfoAPI } from '@/services/user'
import { useUserStore } from '@/stores/user'
import { logEventSafe } from '@/plugins/firebase'

interface Props {
    show: boolean
    avatar?: string
}

const props = defineProps<Props>()

const emit = defineEmits<{
    (e: 'update:show', value: boolean): void
    (e: 'confirm', nickname: string): void
}>()

const userStore = useUserStore()
const nickname = ref('')
const imgLoading = ref(false)

/**
 * 关闭弹窗
 */
const handleClose = () => {
    logEventSafe('username_input_popup_click_close')
    emit('update:show', false)
}

/**
 * 图片加载完成
 */
const handleLoad = () => {
    imgLoading.value = true
}

/**
 * 确认名字
 */
const handleConfirm = async () => {
    logEventSafe('username_input_popup_click_confirm')
    handleClose()
    
    if (nickname.value.trim()) {
        await UserInfoAPI.updateUserProfile({
            nickname: nickname.value,
        })
        logEventSafe('username_set_success')
        await userStore.getUserInfo()
        emit('confirm', nickname.value)
    }
}

/**
 * 输入框失焦
 */
const handleBlur = () => {
    logEventSafe('username_input_focus')
}
</script>

<style scoped lang="scss">
// 淡入淡出动画
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.better-box {
    background: linear-gradient(180deg, rgba(1, 3, 27, 0) 0%, rgba(1, 3, 27, 0.3) 10%, #01031B 60%);

    .bg-color {
        background: rgba(0, 0, 0, 0.1);
    }

    .btn-primary {
        background: linear-gradient(90deg, #5A68FF 0%, #95A5FF 100%);
        font-weight: 800;
        font-size: 16px;
        color: #FFFFFF;
        border-radius: 23px;
        padding: 12px;
        margin-top: 20px;
        cursor: pointer;
        transition: opacity 0.2s;

        &:active {
            opacity: 0.8;
        }
    }
}
</style>
